// extracted by mini-css-extract-plugin
export default {"currencies":"currencies_currencies","queryInput":"currencies_queryInput","list":"currencies_list","hint":"currencies_hint","noResults":"currencies_noResults"};